import { useCallback } from 'react';
import { useLogMarketAnalyticsEvent } from '../../../hooks/useLogMarketAnalyticsEvent';

export const useLogClickMarketSearch = () => {
  const logMarketAnalytics = useLogMarketAnalyticsEvent();

  return useCallback(() => {
    logMarketAnalytics({ name: 'CLICK_MARKET_SEARCH' });
  }, [logMarketAnalytics]);
};
